import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontSize: 10,
    },
    header: {
        marginBottom: 20,
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 'bold',
    },
    subHeader: {
        marginTop: 20,
        marginBottom: 10,
        fontSize: 14,
        fontWeight: 'bold',
    },
    summary: {
        marginBottom: 15,
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    summaryItem: {
        flexDirection: 'column',
    },
    summaryLabel: {
        fontWeight: 'bold',
        marginBottom: 3,
    },
    table: {
        display: "table",
        width: "100%",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        marginBottom: 20,
    },
    tableRow: {
        flexDirection: "row",
    },
    tableColHeader: {
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5,
        fontWeight: 'bold',
        backgroundColor: '#f0f0f0',
    },
    tableCol: {
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5,
    },
    colNarrow: { width: "8%" },
    colDate: { width: "12%" },
    colCategory: { width: "14%" },
    colDesc: { width: "22%" },
    colPayment: { width: "12%" },
    colVendor: { width: "14%" },
    colAmount: { width: "18%" },
});

const formatShortDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('en-US');
};

const ExpensePDFReport = ({ reportData, startDate, endDate }) => {
    const details = reportData?.expense_details || [];
    const totalAmount = reportData?.total_amount || 0;

    return (
        <Document>
            <Page size="A4" style={styles.page} orientation="landscape">
                <Text style={styles.header}>
                    Expense Report from {formatShortDate(startDate)} to {formatShortDate(endDate)}
                </Text>

                <View style={styles.summary}>
                    <View style={styles.summaryItem}>
                        <Text style={styles.summaryLabel}>Total Expenses:</Text>
                        <Text>₹{totalAmount.toFixed(2)}</Text>
                    </View>
                    <View style={styles.summaryItem}>
                        <Text style={styles.summaryLabel}>Total Entries:</Text>
                        <Text>{reportData?.total_count || 0}</Text>
                    </View>
                    <View style={styles.summaryItem}>
                        <Text style={styles.summaryLabel}>Report Generated:</Text>
                        <Text>{new Date().toLocaleString()}</Text>
                    </View>
                </View>

                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableColHeader, styles.colNarrow]}><Text>S.No</Text></View>
                        <View style={[styles.tableColHeader, styles.colDate]}><Text>Date</Text></View>
                        <View style={[styles.tableColHeader, styles.colCategory]}><Text>Category</Text></View>
                        <View style={[styles.tableColHeader, styles.colDesc]}><Text>Description</Text></View>
                        <View style={[styles.tableColHeader, styles.colPayment]}><Text>Payment</Text></View>
                        <View style={[styles.tableColHeader, styles.colVendor]}><Text>Vendor</Text></View>
                        <View style={[styles.tableColHeader, styles.colAmount]}><Text>Amount (₹)</Text></View>
                    </View>
                    {details.map((row, index) => (
                        <View style={styles.tableRow} key={row.id}>
                            <View style={[styles.tableCol, styles.colNarrow]}><Text>{index + 1}</Text></View>
                            <View style={[styles.tableCol, styles.colDate]}><Text>{formatShortDate(row.expense_date)}</Text></View>
                            <View style={[styles.tableCol, styles.colCategory]}><Text>{row.category_name || '-'}</Text></View>
                            <View style={[styles.tableCol, styles.colDesc]}><Text>{(row.description || '-').substring(0, 40)}{(row.description || '').length > 40 ? '...' : ''}</Text></View>
                            <View style={[styles.tableCol, styles.colPayment]}><Text>{row.payment_mode || '-'}</Text></View>
                            <View style={[styles.tableCol, styles.colVendor]}><Text>{(row.vendor_name || '-').substring(0, 20)}{(row.vendor_name || '').length > 20 ? '...' : ''}</Text></View>
                            <View style={[styles.tableCol, styles.colAmount]}><Text>{row.amount?.toFixed(2) || '0.00'}</Text></View>
                        </View>
                    ))}
                </View>
            </Page>
        </Document>
    );
};

export default ExpensePDFReport;
